// extracted by mini-css-extract-plugin
export default {"root":"Input_root__Bqvpq","input":"Input_input__P3tdZ","disabled":"Input_disabled__LFKyx"};